export enum UIType {
    BASIC_MODE_UI,
    ADVANCE_MODE_UI
}
export enum LotScreenSettings {
    CONTACT_LIST_SCREEN,
    CAN_CHUYEN_SCREEN,
    SETTING_SCREEN,
    LAM_VIEC_MIEN_BAC_SCREEN,
    EDIT_CONTACT_SCREEN,
    LOGIN_SCREEN,
    NHAP_TIN_NHAN_SCREEN,
    TOTAL_REPORT_BY_CONTACT_SCREEN,
    MESSAGE_DETAILS_SCREEN,
    CONG_NO_NGAY_SCREEN,
    MAIN_REPORT_SCREEN,
    ADMIN_SCREEN,
    EDIT_AGENT_SCREEN,
    TRON_SO_SCREEN,
    BOT_SETTINGS_SCREEN,
}